<template>
	<v-container>
		<v-skeleton-loader type="list-item-three-line, divider, article, divider" v-if="loading"></v-skeleton-loader>
		<v-row v-for="litter in litters" :key="litter.id">
			<v-card class="col-12  mx-auto mt-4">
				<v-card-title>
					<v-btn  class="col-2 text-h2" x-large outlined :to="{name:'Pedigree', params:{id: litter.litter}}" >
						{{ litter.litter }}
					</v-btn>
					<v-col class="col-10">
						<strong>Sir: <b> {{ litter.male.name   }}</b></strong><br>
						<strong>Dam: <b> {{ litter.female.name }}</b></strong>
					</v-col>
				</v-card-title>
				<v-card-subtitle class="col-4">{{ litter.birthday }}</v-card-subtitle>

					<v-data-table :items="litter.puppys" :headers="puppys">
						<template v-slot:item.animal.sex="{ item }">
							<template v-if="item.animal.sex==='M'">&male;</template> 
							<template v-else>&female;</template>
						</template>
					</v-data-table>
			</v-card>
		</v-row>
	</v-container>
</template>


<script>
import axios from 'axios'
//import VueAxios from 'vue-axios'

export default {
	name: 'Litters',
	data() {
		return {
			litters:null,
			puppys: [
				{text:'Пол', value:'animal.sex',},
				{text:'Кличка', value:'animal.name',},
				{text:'Окрас', value:'animal.color',},
			],
			loading:true,
		}
	},
	methods: {
		getLitters() {
			var url = 'http://catahoulakennel.ru/api/v1/pedigree/litters'
			axios.get(url)
			.then(response => {console.log(response['data']); this.litters = response['data']; this.loading = false})
		}
	},
	beforeMount(){
		this.getLitters()
	}
}
</script>